<script lang="ts">
  import { WifiOff } from '@lucide/svelte';
  import { fa } from '../i18n/fa';
  import { online } from '../lib/online.svelte';
</script>

<!-- Offline is shown loudly; nothing is saved silently for later (ADR-010). -->
{#if !online.value}
  <div role="alert" class="sticky top-0 z-50 flex items-center gap-2 bg-danger-solid px-4 py-2 text-sm text-white">
    <WifiOff class="size-4 shrink-0" aria-hidden="true" />
    <span>{fa.app.offline}</span>
  </div>
{/if}
